import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useMerchant } from "@/hooks/useMerchant";
import { FiltersType } from "../types/filters.type";

export function useFetchSubscriptionGuests(
  filters: FiltersType,
  cursor?: string
) {
  const { merchant } = useMerchant();
  const trpc = useTRPC();

  const queryFilters = useMemo(
    () => ({
      rentalsMerchantId: merchant?.id ?? "",
      documentNumber: filters.documentNumber?.trim() || undefined,
      subscriptionSinceRange: filters.dateRange
        ? ([
            `${filters.dateRange[0]}T00:00:00.000`,
            `${filters.dateRange[1]}T23:59:59.999`,
          ] as [string, string])
        : undefined,
      cursor,
    }),
    [merchant?.id, filters, cursor]
  );

  const { data, isPending, refetch } = useQuery({
    ...trpc.subscriptionGuests.listActive.queryOptions(queryFilters),
    enabled: !!merchant?.id,
  });

  const guests = data?.guests || [];
  const nextCursor = data?.cursor || undefined;

  return {
    guests,
    nextCursor,
    totalItems: guests.length,
    isLoading: isPending,
    refetch,
  };
}
